<template>
  <label
    class="jps-ui-icon-radio-button"
    :class="[
      `size-${size}`,
      {
        'is-active': modelValue === value,
        'has-icon': icon,
      }
    ]"
  >
    <input
      :id="id"
      v-model="picked"
      class="input"
      :value="value"
      type="radio"
      :ariaLabel="arialabel"
    />
    <BaseIcon
      v-if="icon"
      :name="icon"
      :alt="arialabel"
      :size="iconSize"
    />
    <slot />
  </label>
</template>

<script lang="ts" setup>
import type { SVG_NAMES } from '~/components/icons'

interface Props {
  icon?: SVG_NAMES
  id: string
  modelValue: string
  value: string
  arialabel: string
  innerClass?: string
  size?: 'small' | 'medium' | 'large'
}
const props = withDefaults(defineProps<Props>(), {
  innerClass: '',
  size: 'medium',
})
const emits = defineEmits(['update:modelValue'])

const picked = computed({
  get: () => props.modelValue,
  set: value => emits('update:modelValue', value),
})

const iconSize = (() => {
  switch (props.size) {
    case 'small':
      return 'size-6'
    case 'large':
      return 'size-3'
    default:
      return 'size-4'
  }
})()
</script>
<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-ui-icon-radio-button {
  display: inline-flex;
  cursor: pointer;
  color: $jps-gray-500;
  justify-content: center;
  align-items: center;

  &:hover {
    color: $jps-gray-700;
  }

  &.is-active {
    color: $jps-key-blue;

    &:hover {
      color: $jps-key-blue-hover;
    }

  }

  .input {
    display: none;
  }
}

.hina .jps-ui-icon-radio-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  padding: 0.25rem;

  &:hover {
    color: $hina-accent-green-accessible;
  }

  &.is-active {
    color: $hina-accent-green-accessible;
    background-color: $hina-background-green;

    &:hover {
      color: $hina-accent-green;
    }
  }
}

.size-small {
  &.has-icon {
    min-width: $size-4;
    min-height: $size-4;
  }
}

.size-medium {
  &.has-icon {
    min-width: $size-3;
    min-height: $size-3;
  }
}

.size-large {
  &.has-icon {
    min-width: $size-2;
    min-height: $size-2;
  }
}
</style>